import {
  allocationCellKey,
  subAccountReportId,
} from '@ovComponents/4-module/widgets/portfolio/components/allocationCellKey';
import type { CustomAllocationSubAccountReport } from '@ovComponents/4-module/widgets/portfolio/components/buildCustomAllocationInput';
import { isCashHolding } from './cashHolding';

export type SolvedViolationCell = { sa: string; fp: string; fraction: number };

export const buildSolvedViolationCells = ({
  subAccounts,
  rowTargetFraction,
  draft,
  persistedFractionOf,
}: {
  subAccounts: CustomAllocationSubAccountReport[] | undefined;
  rowTargetFraction: Map<string, number>;
  draft: Map<string, number>;
  persistedFractionOf: (sa: string, fp: string, modelTarget: number) => number;
}) => {
  const cells: SolvedViolationCell[] = [];

  for (const subAccount of subAccounts ?? []) {
    const sa = subAccountReportId(subAccount);

    for (const holding of subAccount.holdings ?? []) {
      const fp = holding.financialProduct.id;
      if (!fp || isCashHolding(fp, holding)) continue;

      const modelTarget = rowTargetFraction.get(fp) ?? 0;
      const key = allocationCellKey(sa, fp);
      const fraction =
        draft.get(key) ?? persistedFractionOf(sa, fp, modelTarget);
      cells.push({ sa, fp, fraction });
    }
  }

  return cells;
};
